import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategorySection() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            漫画分类
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            无论您喜欢什么类型的韩国漫画，爱漫画都能满足您的需求
          </p>
        </div>

        <div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.filter(c => c.id !== 'all').map((category) => (
            <Link
              key={category.id}
              to={`/category?cat=${category.id}`}
              className="flex flex-col items-center gap-2.5 p-4 md:p-5 bg-background-50 rounded-xl hover:bg-accent-100/60 transition-all duration-200 group cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-500 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-200">
                <i className={`${category.icon} text-xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-accent-700 transition-colors duration-200 whitespace-nowrap">
                {category.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}